/* eslint-disable quotes */
export const FRONTEND_ALERT_ERROR = 'FRONTEND_ALERT_ERROR';
export const FRONTEND_STACK = 'FRONTEND WEBAPP';
export const WRONG_ADDRESS = 'Votre adresse est incorrecte ou incomplète.';
export const UNAVAILABLE_ADDRESS =
  'Désolé, nous ne livrons pas dans cette zone actuellement.';
export const NO_SHOP_SELECTED_ERROR_MESSAGE =
  'Vous devez sélectionner un point de vente.';
export const NO_SHOP_AVAILABLE_ERROR_MESSAGE =
  "Malheureusement, aucun magasin n'est disponible actuellement.";

export const LEVELS = {
  INFO: 'info',
  ERROR: 'error',
};
export const SEVERITY = {
  LOW: 'low',
  MEDIUM: 'medium',
  HIGH: 'high',
};

export const EMAIL_ALREADY_USED_IN_FIREBASE_AUTH = 'Cette adresse email est déjà utilisée sur l’un de nos services.\n' +
  'Pour poursuivre, veuillez en saisir une autre.';
export const EMAIL_EMPTY_DATA_ACCOUNT = 'Aucune donnée n\'est associée à ce compte.\n Veuillez réessayer avec un email différent.';
export const EMPTY_CART_ERROR =
  "Votre panier est vide. Choisissez un produit pour pouvoir commander.";

export const MINIMUM_ORDER_DELIVERY_ERROR = (amountFormatted) =>
  `Votre panier doit être supérieur à ${amountFormatted} pour pouvoir passer une commande.`;

export const MINIMUM_ORDER_CLICK_AND_COLLECT_ERROR = (amountFormatted) =>
  `Votre panier doit être supérieur à ${amountFormatted} pour pouvoir passer une commande.`;

export const MINIMUM_STRIPE_PAYMENT_ERROR = (amountFormatted) =>
  `Votre panier doit être supérieur à ${amountFormatted} pour pouvoir utiliser le paiement en ligne.`;

export const PAYMENT_NOT_AVAILABLE =
  "Le paiement est actuellement indisponible. Veuillez contacter le restaurant pour plus d’informations.";

